/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Form_Rule_Operator_GtInputs */



/**
* | output |
* | --- |
* | "greater than" |
*
* @param {Alarms_Form_Rule_Operator_GtInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const alarms_form_rule_operator_gt = /** @type {((inputs?: Alarms_Form_Rule_Operator_GtInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Form_Rule_Operator_GtInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("greater than")
	return /** @type {LocalizedString} */ ("supérieure à")
});